import { useState } from "react";

interface RequestsTabProps {
  onFrameChange?: (range: string) => void;
  selectedFrame?: string;
  options?: string[];
}

const RequestsTab: React.FC<RequestsTabProps> = ({
  onFrameChange,
  selectedFrame,
  options = ["Active", "Scheduled", "History"],
}) => {
  const [selected, setSelected] = useState<string>(options[0]);

  const handleSelect = (option: string) => {
    setSelected(option);
    onFrameChange?.(option);
  };

  const getButtonClass = (option: string) =>
    (selectedFrame || selected) === option
      ? "text-black font-bold border-b-[3px] -mb-2 py-[0.5px] border-black dark:text-white dark:bg-gray-800"
      : "text-black font-[300] dark:text-gray-400";

  return (
    <div className="w-full box-sizing:border-box border-b-4">
      <div className="flex w-full items-center gap-1.5 dark:bg-gray-900">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => handleSelect(option)}
            className={`px-3 py-2 h-9 font-medium text-sm whitespace-nowrap hover:text-gray-900 dark:hover:text-white ${getButtonClass(
              option
            )}`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RequestsTab;
